import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Route, Routes, Navigate } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import VoterNavbar from '../components/VoterNavbar'
import { device, spacing } from '../styles/_var'
import VoterDashboard from './VoterDashboard/VoterDashboard'
import VotingCredits from './VoterDashboard/VotingCredits'
import CreateCompetition from './VoterDashboard/CreateCompetition/CreateCompetition'
import { menuItems } from '../utils/constants'
import MyCompetitions from './VoterDashboard/MyCompetitions/MyCompetitions'
import MyAccount from './VoterDashboard/MyAccount'
import VoterSettings from './VoterDashboard/VoterSettings/VoterSettings'
import useRenderOnAuthenticated from '../hooks/useRenderOnAuthenticated'
import authStore from '../stores/authStore'
import { observer } from 'mobx-react-lite'
import InActiveUserNotification from '../components/InActiveUserNotification'
import competitionDashboardStore from '../stores/competitionDashboardStore'

const DashboardRoutes = () => {
  useEffect(() => {
    competitionDashboardStore.clearData()
  }, [])
  const shouldLoadPage = useRenderOnAuthenticated()
  if (!shouldLoadPage) return null

  const renderRoutes = () => {
    return (
      <Routes>
        <Route path='' element={<Navigate to='home' replace />} />
        <Route path='home' element={<VoterDashboard />} />
        <Route path='voting-credits' element={<VotingCredits />} />
        <Route path='competitions' element={<MyCompetitions />} />
        <Route path='my-account' element={<MyAccount />} />
        <Route path='settings' element={<VoterSettings />} />
        <Route path='competitions/create' element={<CreateCompetition />} />
      </Routes>
    )
  }

  return (
    <DashboardWrapper>
      <Sidebar
        username={authStore.username}
        menuItems={menuItems}
        disabled={!authStore.isUserActive}
        firstName={authStore.userFirstName}
        avatar={authStore.userAvatar} />
      <BodySection>
        <VoterNavbar />
        <DashboardContainer>
          {authStore.isUserActive ? renderRoutes() : <InActiveUserNotification />}
        </DashboardContainer>
      </BodySection>
    </DashboardWrapper>
  )
}

export default observer(DashboardRoutes)

export const BodySection = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;
  position: absolute;

  @media ${device.tablet} {
    width: calc(100% - 28rem);
    right: 0;
  }
`

export const DashboardWrapper = styled.div`
  position: absolute;
  width: 100%;
`

export const DashboardContainer = styled.div`
  padding: ${spacing.sm} 0;
  max-width: 1200px;
  margin: 0 auto;

  @media ${device.tablet} {
    padding: ${spacing.rg} 0;
  }
`